import React from 'react'
import { DeleteIcon } from '../../../conf/images'
import { TextMessageContent } from '../interface'

interface TextMessageDefaultProps extends TextMessageContent {
    onChange: (s: TextMessageContent) => void
    onDelete: () => void
}

const TextMessageDefault: React.FC<TextMessageDefaultProps> = (props) => {
    return (
        <div className='textMessageBox'>
            <input
                value={props.content}
                onChange={(e) => props.onChange({ content: e.target.value })}
                placeholder='请输入文字'
            />
            <img
                onClick={props.onDelete}
                src={DeleteIcon}
                alt='deleteIcon'
                className='messageDeleteIcon'
            />
        </div>
    )
}

export default TextMessageDefault
